import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Directive({
  selector: '[appAccessControl]'
})
export class AccessControlDirective implements OnInit {
  @Input() accessRoles: string;
  @Input() accessPermissions: string;

  constructor(
    private elementRef: ElementRef,
    private auth: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.checkAccess();
  }

  checkAccess(): void {
    const user = this.auth.currentUserValue;

    if (!user || !this.checkAccessRoles() || !this.checkAccessPermissions()) {
      this.elementRef.nativeElement.remove();
    }
  }

  checkAccessRoles(): boolean {
    const accessRoles = this.auth.currentUserValue?.UserRoles ?? [];
    const rolesList = this.accessRoles
      ?.split(',')
      .map(role => role.trim())
      .filter(Boolean) ?? [];

    return !rolesList.length ||
      rolesList.some(role => accessRoles.includes(role));
  }

  checkAccessPermissions(): boolean {
    const accessPermissions =
      this.auth.currentUserValue?.TrainingPermissions ?? [];

    const permissionsList = this.accessPermissions
      ?.split(',')
      .map(permission => permission.trim())
      .filter(Boolean) ?? [];

    return !permissionsList.length ||
      permissionsList.some(permission =>
        accessPermissions.includes(permission)
      );
  }
}
